import { render, staticRenderFns } from "./cadastro.vue?vue&type=template&id=1f4eab3c&scoped=true&"
import script from "./cadastro.vue?vue&type=script&lang=js&"
export * from "./cadastro.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/bootstrap4.css?vue&type=style&index=0&id=1f4eab3c&scoped=true&lang=css&"
import style1 from "./cadastro.vue?vue&type=style&index=1&id=1f4eab3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4eab3c",
  null
  
)

export default component.exports